import { render, staticRenderFns } from "./ProgramToggle.vue?vue&type=template&id=50970028&"
import script from "./ProgramToggle.vue?vue&type=script&lang=js&"
export * from "./ProgramToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports